import { PhotoListModel } from '@App/common/models/photoList.mdl';
// import { PhotoListModel } from '../models/photoList.mdl';

export const PhotoData: PhotoListModel[] = [
  {
    'category': 'home',
    'numberOfPhotos': 3,
    'photoList': [
      {
        'id': '2',
        'description': '',
        'displaySrc': '/md/img/home/1809_ST_049p.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        'orientation': 'tall'
        // 'url': ''
      },
      {
        // mobile
        'id': '1',
        'description': '',
        'displaySrc': '/md/img/home/1506_june16_105.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        'orientation': 'both'
        // 'url': ''
      },
      // full screen
      {
        'id': '3',
        'description': '',
        'displaySrc': '/md/img/home/1705_AC_304.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        'orientation': 'both'
        // 'url': ''
      },
      {
        'id': '4',
        'description': '',
        'displaySrc': '/md/img/home/1502_Viet_753.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        'orientation': 'wide'
        // 'url': ''
      },
      {
        'id': '5',
        'description': '',
        'displaySrc': '/md/img/home/1211_CF_255.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        'orientation': 'wide'
        // 'url': ''
      },
      {
        'id': '6',
        'description': '',
        'displaySrc': '/md/img/home/1210_HB_52.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        'orientation': 'wide'
        // 'url': ''
      },
    ]
  },
  {
    'category': 'lifestyle',
    'numberOfPhotos': 31,
    'photoList': [
      {
        'id': '1',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1106_PS_12.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      {
        'id': '3',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1210_HB_52.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      {
        'id': '28',
        'description': '',
        'displaySrc': '/md/img/lifestyle/CooperWorkshop__0726.jpg',
        'title': '',
        'width': 500,
        'height': 417,
        // 'url': ''
      },

      {
        'id': '5',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1211_CF_255.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      {
        'id': '4',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1210_JK_09.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      {
        'id': '6',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1211_SS_055.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      {
        'id': '10',
        'description': '',
        'displaySrc': '/md/img/portraits/110211_Sam_012.jpg',
        'title': '',
        'width': 400,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '29',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1810_DM_124.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      {
        'id': '7',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1304_DL_379.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      {
        'id': '8',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1304_DL_725.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      {
        'id': '9',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1309_acro_089.jpg',
        'title': '',
        'height': 332,
        'width': 382,
        // 'url': ''
      },
      {
        'id': '12',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1309_LT_14.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      {
        'id': '2',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1207_HH-175.jpg',
        'title': '',
        'height': 333,
        'width': 385,
        // 'url': ''
      },
      {
        'id': '11',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1309_Jest_45.jpg',
        'title': '',
        'height': 333,
        'width': 452,
        // 'url': ''
      },
      {
        'id': '10',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1309_clowns_038.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },

      {
        'id': '27',
        'description': '',
        'displaySrc': '/md/img/lifestyle/CooperWorkshop__0320.jpg',
        'title': '',
        'width': 417,
        'height': 500,
        // 'url': ''
      },

      {
        'id': '13',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1502_Viet_109.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      // {
      //   'id': '14',
      //   'description': '',
      //   'displaySrc': '/md/img/lifestyle/1502_Viet_121.jpg',
      //   'title': '',
      //   'height': 333,
      //   'width': 500,
      //   // 'url': ''
      // },
      // {
      //   'id': '15',
      //   'description': '',
      //   'displaySrc': '/md/img/lifestyle/1502_Viet_129.jpg',
      //   'title': '',
      //   'height': 333,
      //   'width': 500,
      //   // 'url': ''
      // },

      {
        'id': '16',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1502_Viet_176.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      {
        'id': '17',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1502_Viet_240.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },

      {
        'id': '18',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1502_Viet_256.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },

      {
        'id': '19',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1502_Viet_582.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      {
        'id': '20',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1502_Viet_597.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },

      {
        'id': '21',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1502_Viet_619.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      // {
      //   'id': '22',
      //   'description': '',
      //   'displaySrc': '/md/img/lifestyle/1502_Viet_673.jpg',
      //   'title': '',
      //   'height': 333,
      //   'width': 500,
      //   // 'url': ''
      // },
      {
        'id': '23',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1502_Viet_688.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      {
        'id': '24',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1502_Viet_694.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      {
        'id': '25',
        'description': '',
        'displaySrc': '/md/img/lifestyle/1502_Viet_753.jpg',
        'title': '',
        'height': 333,
        'width': 500,
        // 'url': ''
      },
      // {
      //   'id': '26',
      //   'description': '',
      //   'displaySrc': '/md/img/lifestyle/Coach.jpg',
      //   'title': '',
      //   'height': 500,
      //   'width': 497,
      //   // 'url': ''
      // },





      // {
      //   'id': '30',
      //   'description': '',
      //   'displaySrc': '/md/img/lifestyle/KSNurs_08.jpg',
      //   'title': '',
      //   'width': 333,
      //   'height': 500,
      //   // 'url': ''
      // },
    ]
  },
  {
    'category': 'events',
    'numberOfPhotos': 39,
    'photoList': [


      {
        'id': '3',
        'description': '',
        'displaySrc': '/md/img/events/1203_STIP_056.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      // {
      //   'id': '4',
      //   'description': '',
      //   'displaySrc': '/md/img/events/1207_PV_242.jpg',
      //   'title': '',
      //   'width': 500,
      //   'height': 333,
      //   // 'url': ''
      // },
      {
        'id': '6',
        'description': '',
        'displaySrc': '/md/img/events/1304_BMN_460.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '12',
        'description': '',
        'displaySrc': '/md/img/events/1506_June23_237.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '7',
        'description': '',
        'displaySrc': '/md/img/events/1404_Positioning_111.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '16',
        'description': '',
        'displaySrc': '/md/img/events/1604_JV_083.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      // {
      //   'id': '8',
      //   'description': '',
      //   'displaySrc': '/md/img/events/1409_LMG_648.jpg',
      //   'title': '',
      //   'width': 500,
      //   'height': 333,
      //   // 'url': ''
      // },
      {
        'id': '9',
        'description': '',
        'displaySrc': '/md/img/events/1506_final_471.jpg',
        'title': '',
        'width': 500,
        'height': 500,
        // 'url': ''
      },
      // {
      //   'id': '10',
      //   'description': '',
      //   'displaySrc': '/md/img/events/1506_june12_548.jpg',
      //   'title': '',
      //   'width': 500,
      //   'height': 333,
      //   // 'url': ''
      // },
      {
        'id': '11',
        'description': '',
        'displaySrc': '/md/img/events/1506_june16_105.jpg',
        'title': '',
        'width': 500,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '5',
        'description': '',
        'displaySrc': '/md/img/events/1302_DWD__244.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },

      {
        'id': '13',
        'description': '',
        'displaySrc': '/md/img/events/1506_June27_0743.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },

      {
        'id': '14',
        'description': '',
        'displaySrc': '/md/img/events/1506_match44_0535.jpg',
        'title': '',
        'width': 500,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '15',
        'description': '',
        'displaySrc': '/md/img/events/1506_match44_1111.jpg',
        'title': '',
        'width': 500,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '40',
        'description': '',
        'displaySrc': '/md/img/lifestyle/SC_110.jpg',
        'title': '',
        'height': 500,
        'width': 333,
        // 'url': ''
      },
      {
        'id': '1',
        'description': '',
        'displaySrc': '/md/img/events/1C8A4681.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },

      // {
      //   'id': '19',
      //   'description': '',
      //   'displaySrc': '/md/img/events/1704_BoC_114.jpg',
      //   'title': '',
      //   'width': 500,
      //   'height': 333,
      //   // 'url': ''
      // },
      // {
      //   'id': '20',
      //   'description': '',
      //   'displaySrc': '/md/img/events/1704_BoC_160.jpg',
      //   'title': '',
      //   'width': 500,
      //   'height': 333,
      //   // 'url': ''
      // },
 
      {
        'id': '21',
        'description': '',
        'displaySrc': '/md/img/events/1704_BoC_387.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '22',
        'description': '',
        'displaySrc': '/md/img/events/1705_AC_304.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '18',
        'description': '',
        'displaySrc': '/md/img/events/1605_Phil_031.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '17',
        'description': '',
        'displaySrc': '/md/img/events/1605_Phil_016.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },

      {
        'id': '36',
        'description': '',
        'displaySrc': '/md/img/events/100603_WMG676.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '37',
        'description': '',
        'displaySrc': '/md/img/events/100916_Banq_609.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '2',
        'description': '',
        'displaySrc': '/md/img/events/1111_WS_168.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      // {
      //   'id': '38',
      //   'description': '',
      //   'displaySrc': '/md/img/events/Capture0023.jpg',
      //   'title': '',
      //   'width': 500,
      //   'height': 333,
      //   // 'url': ''
      // },
      {
        'id': '39',
        'description': '',
        'displaySrc': '/md/img/events/PSU_7790.jpg',
        'title': '',
        'width': 500,
        'height': 400,
        // 'url': ''
      },


      {
        'id': '23',
        'description': '',
        'displaySrc': '/md/img/events/1705_TuesPM_016.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      // {
      //   'id': '24',
      //   'description': '',
      //   'displaySrc': '/md/img/events/1710_BA_131.jpg',
      //   'title': '',
      //   'width': 500,
      //   'height': 357,
      //   // 'url': ''
      // },
      {
        'id': '25',
        'description': '',
        'displaySrc': '/md/img/events/1712_HP_043.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '26',
        'description': '',
        'displaySrc': '/md/img/events/1804_FB_479.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      // {
      //   'id': '27',
      //   'description': '',
      //   'displaySrc': '/md/img/events/1805_IPS_163.jpg',
      //   'title': '',
      //   'width': 500,
      //   'height': 333,
      //   // 'url': ''
      // },
      // {
      //   'id': '28',
      //   'description': '',
      //   'displaySrc': '/md/img/events/1805_IPS_705.jpg',
      //   'title': '',
      //   'width': 500,
      //   'height': 333,
      //   // 'url': ''
      // },

      {
        'id': '30',
        'description': '',
        'displaySrc': '/md/img/events/1806_HS_650.jpg',
        'title': '',
        'width': 500,
        'height': 400,
        // 'url': ''
      },
      {
        'id': '31',
        'description': '',
        'displaySrc': '/md/img/events/1806_HS_778.jpg',
        'title': '',
        'width': 500,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '32',
        'description': '',
        'displaySrc': '/md/img/events/081220_sp_101.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '33',
        'description': '',
        'displaySrc': '/md/img/events/090603_WMG_343.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '29',
        'description': '',
        'displaySrc': '/md/img/events/1806_HS_203.jpg',
        'title': '',
        'width': 500,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '34',
        'description': '',
        'displaySrc': '/md/img/events/100224_AB_064.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '35',
        'description': '',
        'displaySrc': '/md/img/events/100228_MHH_244.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },

    ]
  },
  {
    'category': 'groups',
    'numberOfPhotos': 6,
    'photoList': [
      {
        'id': '4',
        'description': '',
        'displaySrc': '/md/img/portraits/1405_MH_179_pp.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        // 'url': ''
      },

      {
        'id': '1',
        'description': '',
        'displaySrc': '/md/img/groups/0501_BCSC_52.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },



      {
        'id': '13',
        'description': '',
        'displaySrc': '/md/img/portraits/WT_EW_03.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '12',
        'description': '',
        'displaySrc': '/md/img/portraits/1708_sp_112.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        // 'url': ''
      },

      {
        'id': '8',
        'description': '',
        'displaySrc': '/md/img/portraits/090124_PF01.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '1',
        'description': '',
        'displaySrc': '/md/img/portraits/1205_CMA_725.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '6',
        'description': '',
        'displaySrc': '/md/img/groups/BoD_06_13.5x16.jpg',
        'title': '',
        'width': 500,
        'height': 400,
        // 'url': ''
      },
      {
        'id': '9',
        'description': '',
        'displaySrc': '/md/img/portraits/100520_Execs_65.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '11',
        'description': '',
        'displaySrc': '/md/img/portraits/110307_FR_70.jpg',
        'title': '',
        'width': 357,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '6',
        'description': '',
        'displaySrc': '/md/img/portraits/1709_sp_77p.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        // 'url': ''
      },
      // {
      //   'id': '29',
      //   'description': '',
      //   'displaySrc': '/md/img/lifestyle/GreyDoc_31.jpg',
      //   'title': '',
      //   'width': 333,
      //   'height': 500,
      //   // 'url': ''
      // },
      {
        'id': '2',
        'description': '',
        'displaySrc': '/md/img/groups/0509_TK_14.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '7',
        'description': '',
        'displaySrc': '/md/img/portraits/1809_ST_049p.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        // 'url': ''
      },
      // {
      //   'id': '3',
      //   'description': '',
      //   'displaySrc': '/md/img/groups/1806_HS_132.jpg',
      //   'title': '',
      //   'width': 500,
      //   'height': 400,
      //   // 'url': ''
      // },
      // {
      //   'id': '4',
      //   'description': '',
      //   'displaySrc': '/md/img/groups/090214_BD_16rt.jpg',
      //   'title': '',
      //   'width': 500,
      //   'height': 333,
      //   // 'url': ''
      // },
      {
        'id': '5',
        'description': '',
        'displaySrc': '/md/img/portraits/1702_AR_196.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      
      {
        'id': '3',
        'description': '',
        'displaySrc': '/md/img/portraits/1403_QSB_032.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        // 'url': ''
      },
      // {
      //   'id': '5',
      //   'description': '',
      //   'displaySrc': '/md/img/groups/200804_LMGcomm_12.jpg',
      //   'title': '',
      //   'width': 500,
      //   'height': 333,
      //   // 'url': ''
      // },

    ]
  },
  {
    'category': 'portraits',
    'numberOfPhotos': 6,
    'photoList': [
      {
        'id': '1',
        'description': '',
        'displaySrc': '/md/img/portraits/1205_CMA_725.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '5',
        'description': '',
        'displaySrc': '/md/img/portraits/1702_AR_196.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '2',
        'description': '',
        'displaySrc': '/md/img/portraits/1310_EY_06.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '3',
        'description': '',
        'displaySrc': '/md/img/portraits/1403_QSB_032.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '4',
        'description': '',
        'displaySrc': '/md/img/portraits/1405_MH_179_pp.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '6',
        'description': '',
        'displaySrc': '/md/img/portraits/1709_sp_77p.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '7',
        'description': '',
        'displaySrc': '/md/img/portraits/1809_ST_049p.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '8',
        'description': '',
        'displaySrc': '/md/img/portraits/090124_PF01.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '9',
        'description': '',
        'displaySrc': '/md/img/portraits/100520_Execs_65.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
      {
        'id': '10',
        'description': '',
        'displaySrc': '/md/img/portraits/110211_Sam_012.jpg',
        'title': '',
        'width': 400,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '11',
        'description': '',
        'displaySrc': '/md/img/portraits/110307_FR_70.jpg',
        'title': '',
        'width': 357,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '12',
        'description': '',
        'displaySrc': '/md/img/portraits/1708_sp_112.jpg',
        'title': '',
        'width': 333,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '13',
        'description': '',
        'displaySrc': '/md/img/portraits/WT_EW_03.jpg',
        'title': '',
        'width': 500,
        'height': 333,
        // 'url': ''
      },
    ]
  },
  {
    'category': 'published',
    'numberOfPhotos': 11,
    'photoList': [
      {
        'id': '9',
        'description': '',
        'displaySrc': '/md/img/published/TVWeek_BCLion.jpg',
        'title': '',
        'width': 375,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '8',
        'description': '',
        'displaySrc': '/md/img/published/McD_CanSoc_1.jpg',
        'title': '',
        'width': 500,
        'height': 375,
        // 'url': ''
      },
      {
        'id': '4',
        'description': '',
        'displaySrc': '/md/img/published/ERHFGala2017-AirSealSystem508x7.jpg',
        'title': '',
        'width': 363,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '2',
        'description': '',
        'displaySrc': '/md/img/published/87488_NHD2017_CrewPosterEn_r2.jpg',
        'title': '',
        'width': 324,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '3',
        'description': '',
        'displaySrc': '/md/img/published/bchydrocanadianliving_Lowres.jpg',
        'title': '',
        'width': 374,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '11',
        'description': '',
        'displaySrc': '/md/img/published/WestworldMagDelgado.jpg',
        'title': '',
        'width': 500,
        'height': 345,
        // 'url': ''
      },
      {
        'id': '10',
        'description': '',
        'displaySrc': '/md/img/published/Westworld_Mag_cars.jpg',
        'title': '',
        'width': 500,
        'height': 222,
        // 'url': ''
      },
      {
        'id': '1',
        'description': '',
        'displaySrc': '/md/img/published/84478_WHD2016_WindowPoster_JasmeetEn_r2.jpg',
        'title': '',
        'width': 343,
        'height': 500,
        // 'url': ''
      },
      // {
      //   'id': '5',
      //   'description': '',
      //   'displaySrc': '/md/img/published/84478_WHD2016_WindowPoster_StephanieEn_r2a.jpg',
      //   'title': '',
      //   'width': 343,
      //   'height': 500,
      //   // 'url': ''
      // },
      {
        'id': '6',
        'description': '',
        'displaySrc': '/md/img/published/ERHF_DM_Fall2017_Poster_85x11JPEG.jpg',
        'title': '',
        'width': 386,
        'height': 500,
        // 'url': ''
      },
      {
        'id': '7',
        'description': '',
        'displaySrc': '/md/img/published/INSPIRED_SENIOR_LIVING_BC_SEP16_Cover.jpg',
        'title': '',
        'width': 386,
        'height': 500,
        // 'url': ''
      },

    ]
  }
];


// WEBPACK FOOTER //
// ./src/common/data/photoData.ts